module.exports = __webpack_public_path__ + "img/ccic-logo-gray.22415422.svg";